import { FormattedMessage } from 'react-intl'

import { InformationCircleIcon } from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

export const SettingsDescription = () => {
  return (
    <Typography
      className="flex items-start gap-2"
      variant="body2"
    >
      <InformationCircleIcon
        style={{ verticalAlign: 'bottom', flex: '0 0 auto' }}
        width={22}
      />
      <span>
        <FormattedMessage id="user.settings.description" />
      </span>
    </Typography>
  )
}
